import React from "react";
import * as Scroll from "react-scroll";
import { Link } from "react-router-dom";

export default function DescriptionSection(props) {
    return (
        <Scroll.Element name="mba-description" className="description">
            <section className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                    {/* <Link to="/mba-program" className="btn title">
                    چرا MBA درایت اولین انتخاب است؟
                    </Link> */}
                    <Link to='' className="btn title">
                        چرا دوره های MBA  دانشگاه صنعتی امیر کبیر:
                    </Link>
                    <p className="text">
                        - ارائه به روز ترین سرفصلهای آموزشی دانشگاههای جهان با دعوت از اساتید برتر داخلی و بین المللی <br/>
                        - بررسی موضوعی مدلهای رفتاری و تصمیم گیری صنایع مختلف با حضور مدیران برتر صنایع مطرح کشور <br/>
                        - ارائه ترکیبی دروس: به صورت آنلاین و کارگاههای حضوری <br/>
                        -ارائه مدرک MBAمعتبر دانشگاه امیرکبیر

                    </p>
                    {/* <Link to="/mba-program" className="btn btn-outline">
                        جزئیات دوره
                    </Link> */}
                </div>
                {/* <div className="col-sm-12 col-md-6 col-xs-12 left">
                    <img
                        src="/images/description.png"
                        alt="description-img"
                        className="unis-img"
                    />
                </div> */}
            </section>
            <div className="text-center scrollDown-btn" onClick={()=>{props.scroll();}}>
                <div className="icon-scroll"></div>
                <div className="icon-scroll-arrow-down"></div>
            </div>
        </Scroll.Element>
    );
}
